import { AnimatePresence, motion } from "framer-motion";
import { Dispatch, FC, SetStateAction } from "react";
import { Trans, useTranslation } from "react-i18next";
import modalImage from "shared/assets/images/modal-pricing.png";
import { ReactComponent as StrmPlans } from "shared/assets/images/strm-plans.svg";
import { CloseOutlined } from "@ant-design/icons";
import "./ModalPricing.scss";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isDistribution?: boolean;
  isLabel?: boolean;
  children?: React.ReactNode;
}

const ModalPricing: FC<ModalProps> = (props) => {
  const { isOpen, setIsOpen, isDistribution, isLabel } = props;
  const { t } = useTranslation();
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsOpen(false)}
          className="modal-pricing-overlay"
        >
          <motion.div
            initial={{ scale: 0, rotate: "12.5deg" }}
            animate={{ scale: 1, rotate: "0deg" }}
            exit={{ scale: 0, rotate: "0deg" }}
            onClick={(e) => e.stopPropagation()}
            className="modal-content"
          >
            {isDistribution && (
              <div>
                <img
                  src={modalImage}
                  alt="pricing"
                  style={{ borderRadius: "0.5rem 0.5rem 0 0" }}
                  className="responsive-pricing-image"
                />
                <div className="modal-content-image">
                  <span className="flex-plan">
                    <StrmPlans />
                    {t("pages.Pricing.modal.distribution.title")}
                  </span>
                  <span className="flex-subtitle">
                    {t("pages.Pricing.modal.distribution.subtitle")}
                  </span>
                  <CloseOutlined
                    onClick={() => setIsOpen(false)}
                    className="close-icon"
                  />
                </div>
                <div className="modal-content-text">
                  <div>
                    <Trans
                      i18nKey={t(
                        "pages.Pricing.modal.distribution.description"
                      )}
                      components={{ span: <span className="green-color" /> }}
                    />
                  </div>
                  <div style={{ marginTop: "2rem", display: "none" }}>
                    {t("pages.Pricing.modal.distribution.footerText")}
                  </div>
                  <span className="button-plan" style={{ display: "none" }}>
                    {t("pages.Pricing.modal.distribution.buttonText")}
                  </span>
                </div>
              </div>
            )}
            {isLabel && (
              <div>
                <img
                  src={modalImage}
                  alt="pricing"
                  style={{ borderRadius: "0.5rem 0.5rem 0 0" }}
                  className="responsive-pricing-image"
                />
                <div className="modal-content-image">
                  <span className="flex-plan">
                    <StrmPlans />
                    {t("pages.Pricing.modal.label.title")}
                  </span>
                  <span className="flex-subtitle">
                    {t("pages.Pricing.modal.label.subtitle")}
                  </span>
                  <CloseOutlined
                    onClick={() => setIsOpen(false)}
                    className="close-icon"
                  />
                </div>
                <div className="modal-content-text">
                  <div>
                    <Trans
                      i18nKey={t("pages.Pricing.modal.label.description")}
                      components={{ span: <span className="green-color" /> }}
                    />
                  </div>
                  <div style={{ marginTop: "2rem", display: "none" }}>
                    {t("pages.Pricing.modal.label.footerText")}
                  </div>
                  <span className="button-plan" style={{ display: "none" }}>
                    {t("pages.Pricing.modal.label.buttonText")}
                  </span>
                </div>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalPricing;
